import React, { useState, useEffect } from 'react' 
import { Icon, Intent } from '@blueprintjs/core'

const ScrollToTopButton = () => {
    const [showScroll, setShowScroll] = useState(false)

    useEffect(() => {
        const checkScrollTop = () => {
            if (!showScroll && window.pageYOffset > (.25 * window.innerHeight)) {
                setShowScroll(true)
            } else if (showScroll && window.pageYOffset <= (.25 * window.innerHeight)) {
                setShowScroll(false)
            }
        }
        window.addEventListener('scroll', checkScrollTop)

        return () => window.removeEventListener('scroll', checkScrollTop)
    }, [showScroll])

    return <Icon
        style={{ width: '100px', margin: 'auto', display: showScroll ? 'block' : 'none' }}
        icon='double-chevron-up'
        iconSize={30}
        intent={Intent.PRIMARY}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    />
}

export default ScrollToTopButton